
import Embed from './embed';

class TextblockEmbed extends Embed {
  static create(value) {
    const node = super.create(Object.assign(value, {
      label: 'page',
      iconName: 'text_format',
      iconClass: '',
      image: value.src,
      buttons: ['edit'],
      denseMedia: true,
    }));
    node.insertAdjacentHTML('beforeend', this.html(value));

    return node;
  }

  static html({
    textblock,
  }) {
    return `
      <div class="ql-text-wrapper">
        <div>${textblock}</div>
      </div>
    `;
  }

  static value(node) {
    return {
      textblock: node.dataset.embedTextblock,
    };
  }
}

TextblockEmbed.blotName = 'textblockEmbed';
TextblockEmbed.className = 'ql-textblock';
TextblockEmbed.tagName = 'div';

export default TextblockEmbed;
